import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    // ssstufff: each viewport returns to the section's own default view (set in the
    // Customizer, carried on the grid as data attributes) instead of always 'default'.
    const { grid } = this.refs;
    const layout =
      (event.matches ? grid?.dataset.defaultView : grid?.dataset.defaultViewMobile) || 'default';
    const name = event.matches ? 'grid' : 'grid-mobile';

    let targetElement = this.querySelector(`input[type="radio"][name="${name}"][value="${layout}"]`);

    if (!(targetElement instanceof HTMLInputElement)) {
      targetElement = event.matches
        ? this.querySelector('[data-grid-layout="desktop-default-option"]')
        : this.querySelector('[data-grid-layout="mobile-option"]');
    }

    if (!(targetElement instanceof HTMLInputElement)) return;

    for (const option of this.querySelectorAll(`input[type="radio"][name="${name}"]`)) {
      if (option instanceof HTMLInputElement) option.checked = option.value === targetElement.value;
    }

    this.#setLayout(targetElement.value);
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
